import { useState, useCallback, useEffect } from 'react';
export const useDragAndDrop = ({ position, setPosition, size, isMaximized, isMobile })=>{
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({
        x: 0,
        y: 0
    });
    // 드래그 시작 (마우스)
    const handleMouseDown = useCallback((e)=>{
        if (isMaximized || isMobile) return;
        e.stopPropagation();
        setIsDragging(true);
        setDragStart({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    }, [
        position,
        isMaximized,
        isMobile
    ]);
    // 터치 드래그 시작
    const handleTouchStart = useCallback((e)=>{
        if (isMaximized) return;
        e.stopPropagation();
        if (e.touches.length === 1) {
            // 단일 터치 - 드래그
            const touch = e.touches[0];
            setIsDragging(true);
            setDragStart({
                x: touch.clientX - position.x,
                y: touch.clientY - position.y
            });
        }
    }, [
        position,
        isMaximized
    ]);
    // 마우스/터치 이동 처리
    useEffect(()=>{
        const handleMouseMove = (e)=>{
            if (isDragging && !isMaximized) {
                const newX = Math.max(0, Math.min(e.clientX - dragStart.x, window.innerWidth - size.width));
                const newY = Math.max(0, Math.min(e.clientY - dragStart.y, window.innerHeight - size.height));
                setPosition({
                    x: newX,
                    y: newY
                });
            }
        };
        const handleTouchMove = (e)=>{
            if (isMaximized) return;
            if (e.touches.length === 1 && isDragging) {
                const touch = e.touches[0];
                const newX = Math.max(0, Math.min(touch.clientX - dragStart.x, window.innerWidth - size.width));
                const newY = Math.max(0, Math.min(touch.clientY - dragStart.y, window.innerHeight - size.height));
                setPosition({
                    x: newX,
                    y: newY
                });
            }
        };
        const handleMouseUp = ()=>{
            setIsDragging(false);
        };
        const handleTouchEnd = ()=>{
            setIsDragging(false);
        };
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('touchmove', handleTouchMove, {
                passive: false
            });
            document.addEventListener('mouseup', handleMouseUp);
            document.addEventListener('touchend', handleTouchEnd);
        }
        return ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('touchend', handleTouchEnd);
        };
    }, [
        isDragging,
        dragStart,
        position,
        size,
        isMaximized,
        setPosition
    ]);
    return {
        isDragging,
        handleMouseDown,
        handleTouchStart
    };
};
